<template>
    <v-card class="main-content-card" flat id="proj-index-card">
        <v-toolbar flat>
            <v-toolbar-title>科研来款管理</v-toolbar-title>
            <span class="subheading ml-2">|</span>
          <v-btn round small color="orange darken-1" class="white--text"
                 @click.native.stop="() => { editDbid = null; edit = true; }">
            <v-icon dark small>money</v-icon>来款登记
          </v-btn>
        </v-toolbar>
        <v-divider/>

        <!-- 检索功能区 -->
        <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
            <v-layout row wrap>
                <v-flex d-flex xs10>
                    <v-layout row wrap>
                        <v-flex xs12 sm5>
                            <v-text-field
                                    label="对方单位"
                                    v-model="form.dfdw"
                                    :clearable="true"
                                    hide-details/>
                        </v-flex>
                        <v-flex xs12 sm4>
                            <v-text-field
                                    label="摘要"
                                    v-model="form.zy"
                                    :clearable="true"
                                    hide-details/>
                        </v-flex>
                        <v-flex xs12 sm3>
                            <v-text-field
                                    label="金额"
                                    v-model="form.je"
                                    :clearable="true"
                                    hide-details/>
                        </v-flex>
                        <v-flex xs12>
                            <span>审核状态：</span>
                            <v-btn-toggle
                                    v-model="form.statusId"
                                    class="transparent"
                                    style="background:none;box-shadow:none">
                                <v-btn value="" flat>全部</v-btn>
                                <v-btn flat v-for="s in statusItems" :key="s.dbid" :value="s.identifier">{{s.name}}
                                </v-btn>
                            </v-btn-toggle>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex d-flex xs2 text-xs-center>
                    <div>
                        <v-btn color="primary" @click="onSearch">
                            <v-icon dark>search</v-icon>
                            检索
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
        <v-divider/>

        <v-data-table
                :headers="headers"
                :loading="loading"
                item-key="dbid"
                :pagination.sync="query"
                :items="pageResult.items"
                :total-items="pageResult.total"
                :rows-per-page-items="[10, 25, 50, 100, 200]">
            <template slot="items" slot-scope="props">
                <td>
                    {{ props.index + 1}}
                </td>
                <td class="text-xs-center">{{props.item.pznm }}</td>
                <td class="text-xs-center">{{props.item.zy}}</td>
                <td class="text-xs-center">{{props.item.dfdw}}</td>
                <td class="text-xs-center">{{props.item.je}}</td>
                <td class="text-xs-center">{{props.item.pzrq}}</td>
                <td class="text-xs-center">{{props.item.lkbz}}</td>
                <!--根据中医大需求，暂时屏蔽<td class="text-xs-center">{{ properties[props.item.lxbh] }}</td>-->
                <td class="text-xs-center">{{ props.item.rkbz=='01'?'已认领':'未认领' }}</td>
                <td class="text-xs-center">{{ props.item.rkrq}}</td>
                <td>
                    <v-tooltip top>
                        <v-chip small label class="mx-0" slot="activator"
                                :color="props.item.color"
                                @click="() => { history=props.item.history; hist = true; }">
                            {{ props.item.statusname }}
                        </v-chip>
                        <span>点击查看审核历史</span>
                    </v-tooltip>
                </td>
                <td class="justify-center layout px-0">
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               @click="() => {savePznm = props.item.pznm; saveFlbh = props.item.flbh; saveP = true; }"
                               :disabled="!funcIds.includes('u_lkxx_claim')">
                            <v-icon color="teal">more_horiz</v-icon>
                        </v-btn>
                        <span>查看/认领</span>
                    </v-tooltip>
                    <!--
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               @click="() => { $router.push(`/proj/incoclaim/claimCheck/${props.item.pznm}`+`&${props.item.flbh}`) }"
                               :disabled="reviewDisabled(props.item)|| props.item.statusId==='checked'">
                            <v-icon color="teal">playlist_add_check</v-icon>
                        </v-btn>
                        <span>审核</span>
                    </v-tooltip>-->
                  <v-tooltip top>
                    <v-btn icon class="mx-0" slot="activator"
                           @click="() => {
                             deleDbid = props.item.pznm;
                             deleMsg = '来款登记：由' + props.item.dfdw + '汇来的到款' + props.item.zy + '，金额' + props.item.je + '元将被删除！';
                             dele = true; }"
                           :disabled="deleteDisabled(props.item)">
                      <v-icon color="pink">delete_forever</v-icon>
                    </v-btn>
                    <span>删除</span>
                  </v-tooltip>

                    <!--根据中医大需求，暂时屏蔽
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               @click="() => { $router.push(`/proj/incoclaim/claimManage/${props.item.pznm}`+`&${props.item.flbh}`) }"
                               :disabled="manageDisabled()">
                            <v-icon color="teal">toc</v-icon>
                        </v-btn>
                        <span>认领管理</span>
                    </v-tooltip>
                    -->

                </td>
            </template>
        </v-data-table>

        <x-view-save
                v-model="saveP"
                :dbid="savePznm"
                :flbh="saveFlbh"
                v-on:ok="onEditOk"
        />
        <x-history
                v-model="hist"
                :history="history"
                :status="statusItems"
        />
        <x-edit
                v-model="edit"
                :dbid="editDbid"
                v-on:ok="onEditOk"
        />
        <x-delete
                v-model="dele"
                :message="deleMsg"
                :uri="deleUri"
                :dbid="deleDbid"
                v-on:ok="onDeleOk"
        />
    </v-card>
</template>

<script>
    import {mapGetters} from "vuex"
    import XViewSave from './incoClaimTeac'
    import XHistory from '@/components/global/History'
    import XDelete from '@/components/global/Delete'

    import mixin from '@/mixin'
    import XEdit from './Edit'
    const baseUri = '/api/proj/incoclaim/';
    const statusUri = '/api/proj/incoclaim/status';
    const deleteByPznmUri = '/api/proj/incoclaim/bypznm';

    export default {
        // 混入模块主页面（index）基本功能
        mixins: [mixin.index(baseUri)],
        components: {XViewSave, XHistory, XEdit, XDelete},

        data() {
            return {
                uri: baseUri,
                deleUri: deleteByPznmUri,
                loading: false,
                total: 0,
                items: [],
                // 检索、分页、排序条件条件
                query: {
                    dfdw: '',
                    zy: '',
                    je: '',

                    page: 1,
                    rowsPerPage: 25,
                    sortBy: null,
                    descending: null,
                    totalItems: null
                },

                form: {
                    "pznm": "",
                    "flbh": "",
                    "zy": "",
                    "dfdw": "",
                    "je": "",
                    "lxbh": "",
                    "xmbh": "",
                    "bmbh": "",
                    "kmbh": "",
                    "dch": "",
                    "zrr": "",
                    "pzbh": "",
                    "pzrq": "",
                    "zdr": "",
                    "projId": "",
                    "rkrq": "",
                    "rkbz": "",
                    "statusId": "",
                    "statusname": "",
                    "color": "",
                    "leaderName":"",
                    "claimName": ""
                },

                statusItems: [],

                // 表头
                headers: [
                    {text: '#', align: 'left', sortable: false, value: 'dbid', width: "2rem"},
                    {text: '来款ID', align: 'center', sortable: true, value: 'pznm'},
                    {text: '摘要', align: 'center', sortable: true, value: 'zy'},
                    {text: '对方单位', align: 'center', sortable: true, value: 'dfdw'},
                    {text: '金额', align: 'center', sortable: true, value: 'je'},
                    {text: '来款日期', align: 'center', sortable: true, value: 'pzrq'},
                    {text: '资金性质', align: 'center', sortable: true, value: 'lkbz'},
                    {text: '认领标识', align: 'center', sortable: true, value: 'rkbz'},
                    {text: '认领日期', align: 'center', sortable: true, value: 'rkrq'},
                    {text: '审核状态', align: 'left', sortable: true, value: 'status'},
                    {text: '操作', align: 'center', sortable: false, value: ''}
                ],

                properties: {
                    "01": '银行来款',
                    "02": '科研来款',
                    "03": '其它来款'
                },
                flagMaps: {
                    "": '未认领',
                    "1": '已认领'
                },

                saveP: false,
                savePznm: null,
                saveFlbh: null,

                dele: false,
                deleDbid: null,
                deleMsg: null,

                review: false,
                reviewDbid: null,
                reviewMsg: null,
                reviewActs: [],

                hist: false,
                history: [],

                edit: false,
                editDbid: null,

                rules: {

                }
            }
        },

        created() {
            // 加载审核状态
            this.axios.all([
                this.axios.get(statusUri, {params: {sort: 'rank.asc'}})
            ]).then(
                this.axios.spread(
                    (rspStaus) => {
                        this.statusItems = rspStaus.data;
                    }
                )
            )
        },

        computed: {
            ...mapGetters(['funcIds']),
        },

        methods: {
        /*    remote(item, queryText, itemText) {
                return true;
            },*/
            onEditOk(it){
                if (it) {
                    if (!this.savePznm) {
                        this.pageResult.items.unshift(it);
                    } else {
                        const editIdx = this.pageResult.items.findIndex(v => v.pznm === it.pznm);
                        this.pageResult.items[editIdx] = window.xutil.clone(it);
                    }
                }
            },
            // 检索响应函数
            onSearch() {
                Object.assign(this.query, this.form);
                this.query.page = 1;
                this.doRoute(this.query);
            },
            manageDisabled() {
                return !(
                    // 当前用户拥有提交功能
                    (this.funcIds.includes('c_lkxx_manage') ))
            },
            reviewDisabled(item) {
                return !(
                    // 当前用户拥有审核功能
                    this.funcIds.includes('c_lkxx_review')
                    &&(item.statusId=='await'|| item.statusId=='checked')
                )
            },
          deleteDisabled(item) {
            //根据中医大需求，原submitDisabled被修改，故将删除按钮控制修正至此
            return (item.statusname == '已审核')
          },
        },

        watch: {
            // "form.types":(nv) =>{
            //     window.console.log(nv);
            // }
        }
    }
</script>
